import { InMemoryCache } from '@apollo/client';

/**
 * A watchlist refetch is authoritative, so the incoming list must replace the cached one.
 * Without an explicit policy Apollo logs a "Cache data may be lost" warning every time the list
 * shrinks (removing a ticker). Registered under both root names because Hasura reports the root
 * type as `query_root` while Apollo defaults it to `Query`.
 */
export function createApolloCache() {
  const replaceWatchList = { fields: { watch_list: { merge: false } } };

  return new InMemoryCache({
    typePolicies: { Query: replaceWatchList, query_root: replaceWatchList },
  });
}
